export function getAsyncValue<T>(value: T | Promise<T>) {
	// biome-ignore lint/suspicious/noAsyncPromiseExecutor: I dont know why this is done this way
	return new Promise<T>(async (resolve) => {
		const result = value;
		if (result instanceof Promise) {
			await result;
			result.then(resolve);
		} else {
			resolve(result as T);
		}
	});
}

export async function sleep(ms: number) {
	return new Promise((resolve) => setTimeout(resolve, ms));
}
